import {
    ICall, NetworkConfig, ConnectionId,
    MediaConfig, BrowserWebRtcCall, CallEventType,
    DataMessageEventArgs, MessageEventArgs,
    CallAcceptedEventArgs, CallEventArgs, MediaUpdatedEventArgs
} from "../awrtc/index";




describe("Relay", () => {
    function CreateCall(): ICall {

        var nconfig = new NetworkConfig();
        nconfig.SignalingUrl = "wss://devluz.ddns.net:443/relay";

        var call = new BrowserWebRtcCall(nconfig);

        return call;
    }

    it("Video relay test", (done) => {
        var callSend: ICall = null;
        var callRec: ICall = null;
        let callSendToCallRec: ConnectionId;
        let callRecToCallSend: ConnectionId;



        var addressSend = "webunittest_snd";
        var addressRec = "webunittest_rec";
        var remoteFrameCount = 0;
        var maxFrames = 10;

        callSend = CreateCall();
        expect(callSend).not.toBeNull();
        callRec = CreateCall();
        expect(callRec).not.toBeNull();

        var configSend = new MediaConfig();
        configSend.Audio = false;
        configSend.Video = true;
        configSend.FrameUpdates = false;
        configSend.UseDataChannels = false;

        var configRec = new MediaConfig();
        configRec.Audio = false;
        configRec.Video = false;
        configRec.FrameUpdates = true;
        configRec.UseDataChannels = false;

        
        let remoteMediaUpdateReceived: MediaUpdatedEventArgs = null;

        callSend.addEventListener((sender: any, args: CallEventArgs) => {
            if (args.Type === CallEventType.ConfigurationComplete) {
                console.debug("callSend ConfigurationComplete");
                callSend.Listen(addressSend);
            } else if (args.Type === CallEventType.WaitForIncomingCall) {
                console.debug("callSend WaitForIncomingCall");
            } else if (args.Type === CallEventType.CallAccepted) {
                let ar = args as CallAcceptedEventArgs;
                callSendToCallRec = ar.ConnectionId;
                //sender connected to the server side peer and uploading video
                //now continue with receiver side                
                console.debug("callRec listening to " + addressRec);
                callRec.Listen(addressRec);
            }
        });

        callRec.addEventListener((sender: any, args: CallEventArgs) => {
            if (args.Type === CallEventType.ConfigurationComplete) {
                console.debug("callRec ConfigurationComplete");
                //console.debug("callRec listening to " + addressRec);
                //callRec.Listen(addressRec);
            } else if (args.Type === CallEventType.CallAccepted) {
                let ar = args as CallAcceptedEventArgs;
                callRecToCallSend = ar.ConnectionId;
                expect(callRec.HasAudioTrack(callRecToCallSend)).toBeFalse();
                expect(callRec.HasVideoTrack(callRecToCallSend)).toBeTrue();
                console.debug("callRec CallAcceptedEventArgs");
            } else if (args.Type === CallEventType.MediaUpdate) {
                console.debug("callRec MediaUpdate");
                remoteMediaUpdateReceived = args as MediaUpdatedEventArgs;
                expect(remoteMediaUpdateReceived).toBeDefined();
                expect(remoteMediaUpdateReceived).not.toBeNull();
                expect(remoteMediaUpdateReceived.ConnectionId.id).toBe(callRecToCallSend.id);
                expect(remoteMediaUpdateReceived.IsRemote).toBe(true);
                expect(remoteMediaUpdateReceived.VideoElement).toBeDefined();
                expect(remoteMediaUpdateReceived.VideoElement).not.toBeNull();
            } else if (args.Type === CallEventType.FrameUpdate) {
                console.debug("callRec FrameUpdate");
                remoteFrameCount++;
            }

            if (remoteFrameCount >= maxFrames) {
                expect(remoteFrameCount).toBeGreaterThanOrEqual(maxFrames);

                callSend.Dispose();
                callRec.Dispose();
                done();
            }
        });

        setInterval(() => {
            callSend.Update();
            callRec.Update();
        }, 50);

        callSend.Configure(configSend);
        callRec.Configure(configRec);
    });

    //This attempts to connect to a sender before its fully connected
    //TODO: Replace with proper unit test on server side. Not suitabel for integration tests
    it("Video relay early connect", (done) => {
        var callSend: ICall = null;
        var callRec: ICall = null;

        var addressSend = "webunittest_snd";
        var addressRec = "webunittest_rec";

        callSend = CreateCall();
        expect(callSend).not.toBeNull();
        callRec = CreateCall();
        expect(callRec).not.toBeNull();

        var configSend = new MediaConfig();
        configSend.Audio = false;
        configSend.Video = true;
        configSend.FrameUpdates = false;
        configSend.UseDataChannels = false;

        var configRec = new MediaConfig();
        configRec.Audio = false;
        configRec.Video = false;
        configRec.FrameUpdates = true;
        configRec.UseDataChannels = false;
        

        callSend.addEventListener((sender: any, args: CallEventArgs) => {
            if (args.Type === CallEventType.ConfigurationComplete) {
                console.debug("callSend ConfigurationComplete");
                callSend.Listen(addressSend);
            } else if (args.Type === CallEventType.WaitForIncomingCall) {
                console.debug("callSend WaitForIncomingCall");
                console.debug("callRec listening to " + addressRec);
                callRec.Listen(addressRec);
            }
        });

        callRec.addEventListener((sender: any, args: CallEventArgs) => {
            if (args.Type === CallEventType.ConfigurationComplete) {
                console.debug("callRec ConfigurationComplete");
            } else if (args.Type === CallEventType.CallAccepted) {
                let ar = args as CallAcceptedEventArgs;
                fail("CallAccepted before sender was ready");
            } else if (args.Type === CallEventType.ListeningFailed) {
                //expect listening to fail if we connect before the sender is ready
                callSend.Dispose();
                callRec.Dispose();
                done();
            }
        });

        setInterval(() => {
            callSend.Update();
            callRec.Update();
        }, 50);

        callSend.Configure(configSend);
        callRec.Configure(configRec);
    });
    /*
    it("Video relay send", (done) => {
        var callSend: ICall = null;
        let callSendToCallRec: ConnectionId;
        var addressSend = "webunittest_snd";

        callSend = CreateCall();
        expect(callSend).not.toBeNull();

        var configSend = new MediaConfig();
        configSend.Audio = false;
        configSend.Video = true;
        configSend.FrameUpdates = false;
        configSend.UseDataChannels = false;

        callSend.addEventListener((sender: any, args: CallEventArgs) => {
            if (args.Type === CallEventType.ConfigurationComplete) {
                console.debug("callSend ConfigurationComplete");
                callSend.Listen(addressSend);
            } else if (args.Type === CallEventType.WaitForIncomingCall) {
                console.debug("callSend WaitForIncomingCall");
                
            } else if (args.Type === CallEventType.CallAccepted) {
                let ar = args as CallAcceptedEventArgs;
                callSendToCallRec = ar.ConnectionId;
            }
        });
        
        setInterval(() => {
            callSend.Update();
        }, 50);

        callSend.Configure(configSend);
    });*/
});